import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { TokensVService } from '../../../../../services/V2/gozer';
import { handleError } from '../../../../shared/Functions';

export function AddCCTokenModal({ setShow, show, setLoading, loading, billingAccountId }) {
    const [model, setModel] = useState<any>();
    const [count, setCount] = useState<number>(0);

    useEffect(() => {
        TokensVService.tokensVGenerateUrlForm(billingAccountId, { isSaved: true })
            .then(f => setModel(f))
            .catch(err => handleError(err))
    }, [show])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(count > 1){
            setLoading(!loading);
            handleCancel();
        }
    }, [count])// eslint-disable-line react-hooks/exhaustive-deps

    const handleCancel = () => {
        setModel(null)
        setShow(false)
    }

    if(!model) return null;

    return (
        <Dialog
            open={true}
            onClose={handleCancel}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">
                Add CC Token
            </DialogTitle>
            <DialogContent>
                <iframe title="cc-token-creation" onLoad={() => setCount(count + 1)} src={`${model.url}&TextColor=000000&HideReset=1&HideAddress=1&HideCity=1&HideState=1`} style={{ width: "500px", height: "700px", border: "none" }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}